export default __webpack_public_path__ + "static/media/login_flow.0d30771e.png";